import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

// Failures
export const GetFailuresPacketRequest = (userId, role) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}FailuresTracker/GetFailuresPacket`,
	params: { userId, role },
	hasLoading: false
});

export const SetFailurePacketValidInvalidRequest = (userId, id) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}FailuresTracker/SetFailurePacketValidInvalid`,
	params: { userId, id }
});

export const GetFailurePacketDetailsRequest = (id, userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}FailuresTracker/GetFailurePacketDetails`,
	params: { id, userId }
});

export const GetFailurePacketCommentsRequest = (id) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}FailuresTracker/GetFailurePacketComments`,
	params: { id }
});

export const SetFailurePacketDetailsRequest = (trackerPacketDetailsDto, userId) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}FailuresTracker/EditFailurePacketDetails`,
	data: { trackerPacketDetailsDto, userId }
});

export const AddPacketCommentRequest = (id, userId, comment) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}FailuresTracker/AddFailurePacketComment`,
	params: { id, userId, comment }
});

export const ExportFailuresPacketRequest = (userId, role) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}FailuresTracker/ExportFailuresPacket`,
	params: { userId, role }
});

export const GetPacketLevelsRequest = (type, level) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}FailuresTracker/GetPacketLevels`,
	params: { type, level }
});

// Layer3
export const GetLayer3Request = (filenameMoc, filenameMtc, initialTimestamp, userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Layer3/GetLayer3`,
	params: { filenameMoc, filenameMtc, initialTimestamp, userId }
});

export const GetLayer3MessageMoRequest = (id, date, side, userId, filename) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Layer3/GetLayer3Message`,
	params: { id, date, side, userId, filename }
});

export const GetLayer3MessageMtRequest = (id, date, side, userId, filename) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Layer3/GetLayer3Message`,
	params: { id, date, side, userId, filename }
});

export const GetLayer3FailureRequest = (id) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Layer3/GetLayer3Failure`,
	params: { id }
});

export const GetLayer3DriveTestRequest = (userId, kpi, filenameMoc, filenameMtc, failureSide, initialTimestamp, eventTime) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Layer3/GetLayer3DriveTest`,
	params: { userId, kpi, filenameMoc, filenameMtc, failureSide, initialTimestamp, eventTime }
});

export const GetLayer3KpisRequest = (filenameMoc, filenameMtc, failureSide, initialTimestamp, eventTime) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Layer3/GetLayer3Kpis`,
	params: { filenameMoc, filenameMtc, failureSide, initialTimestamp, eventTime }
});
